import { BadgeIndianRupee } from "lucide-react";
import { useLang } from "@/lib/i18n";

export const DisclaimerStrip = () => {
  const { t } = useLang();
  return (
    <section className="disclaimer-strip" data-testid="advance-payment-disclaimer">
      <div className="disclaimer-icon">
        <BadgeIndianRupee size={26} />
      </div>
      <p>
        <strong>{t.disclaimer.lead}</strong> {t.disclaimer.text}
      </p>
    </section>
  );
};
